export const extensionsWithAutomaticPricing = /(\.doc|\.docx|\.pdf)$/i;